import React from 'react';
import P, { InferProps } from 'prop-types';
import { SxStyle } from '../../../types';
import { useStringsContext } from '../../../contexts/strings';
import Grid from '@mui/material/Grid';
import TextInput from './text-field';

const styles: SxStyle = {
  containerInfo: {
    maxWidth: '650px',
  },
};

function PromoFieldVideo({
  setChange,
  setValidation,
  fields,
  isReadOnly,
}: InferProps<typeof PromoFieldVideo.propTypes>) {
  const { strings } = useStringsContext();
  const contentUrlField = fields[0];
  const textField = fields[6];

  return (
    <Grid container spacing={2} direction="column" sx={styles.containerInfo}>
      <Grid item>
        <TextInput
          label={strings.promos.promoVideoUrl}
          helperText={strings.validations.validFotbollPlayUrl}
          field={contentUrlField}
          setChange={setChange}
          setValidation={setValidation}
          key={contentUrlField.id}
          isReadOnly={isReadOnly}
          fullWidth
        />
      </Grid>
      <Grid item>
        <TextInput
          label={strings.promos.promoVideoTitle}
          field={textField}
          setChange={setChange}
          setValidation={setValidation}
          key={textField.id}
          isReadOnly={isReadOnly}
          fullWidth
          maxLength={14}
          helperText="Titeln får maximalt innehålla 14 tecken"
        />
      </Grid>
    </Grid>
  );
}

PromoFieldVideo.propTypes = {
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fields: P.any.isRequired,
  key: P.string,
  path: P.string.isRequired,
};

export default PromoFieldVideo;
